import { render } from "./ActGoal3.vue?vue&type=template&id=343ad373"
import script from "./ActGoal3.vue?vue&type=script&lang=js"
export * from "./ActGoal3.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__